<li class="question-item">
  <div class="title text-07-m-regular text-10-d-regular">{{ question.Title }}</div>

  <div class="maintext text-04-m-demibold text-06-d-demibold">
    {{ getTitleValue(question) }}
    <a class="modal-trigger" data-trigger-modal="slide-left" (click)="openSlide()" data-no-overlay="true">
      <i class="icon icon-edit"></i><i class="icon icon-check" *ngIf="question.IsValid"></i>
      <img src="{{ baseImageUrl }}cj/ws/icon-alert.svg" class="icon icon-alert" *ngIf="!question.IsValid" aria-hidden="true" alt="alert-icon">
    </a>
  </div>

  <span class="text-error in" *ngIf="!isValid(question)">
    {{ getErrorMessage(question) }}
  </span>
</li>
